export const DEFAULT_REHAB_MERCHANT = {
  key: 'default',
  name: '动优康复',
  shortName: '动优康复',
  logo: '',
  browserTitle: '动优康复课程中心',
  themeColor: '#07c160',
  themeColorDark: '#06a84e',
  themeColorLight: '#ecfdf5',
  accentColor: '#ff8f3f',
  courseFilter: null,
  courseSource: null
}

const merchantConfigs = {
  default: DEFAULT_REHAB_MERCHANT,
  jiumiao: {
    ...DEFAULT_REHAB_MERCHANT,
    key: 'jiumiao',
    name: '久苗',
    shortName: '久苗',
    logo: 'https://cdn.keihong.tech/20260417130651655.png',
    browserTitle: '久苗课程中心',
    themeColor: '#0F4E87',
    themeColorDark: '#0B3E6B',
    themeColorLight: '#EAF3FB',
    courseSource: {
      type: 'markdown',
      markdown: ''
    }
  }
}

const normalizeMerchantKey = (merchant) => {
  return String(merchant || '').trim().toLowerCase()
}

const normalizeCourseKeyword = (value) => {
  return String(value || '').trim().toLowerCase()
}

const matchCourseByKeyword = (course, keyword) => {
  const normalizedKeyword = normalizeCourseKeyword(keyword)
  if (!normalizedKeyword) return false

  const fields = [
    course.title,
    course.type,
    course.briefText,
    course.intro,
    course.merchant,
    course.merchantCode,
    course.merchantName,
    course.tags
  ]

  return fields.some(field => normalizeCourseKeyword(field).includes(normalizedKeyword))
}

export const getRehabMerchantConfig = (merchant) => {
  const merchantKey = normalizeMerchantKey(merchant)
  return merchantConfigs[merchantKey] || DEFAULT_REHAB_MERCHANT
}

export const buildRehabMerchantQuery = (query = {}) => {
  const merchant = query.merchant || query.merchantId || query.brand || ''
  return merchant ? { merchant } : {}
}

export const filterRehabCoursesByMerchant = (courses = [], merchantConfig = DEFAULT_REHAB_MERCHANT) => {
  if (!Array.isArray(courses) || !courses.length) return []

  const filter = merchantConfig.courseFilter
  if (!filter) return courses

  const includeCourseIds = Array.isArray(filter.includeCourseIds) ? filter.includeCourseIds.map(item => String(item)) : []
  const excludeCourseIds = Array.isArray(filter.excludeCourseIds) ? filter.excludeCourseIds.map(item => String(item)) : []
  const includeKeywords = Array.isArray(filter.includeKeywords) ? filter.includeKeywords : []
  const excludeKeywords = Array.isArray(filter.excludeKeywords) ? filter.excludeKeywords : []

  return courses.filter(course => {
    const courseId = String(course.id || course.courseId || '')

    if (excludeCourseIds.includes(courseId)) return false
    if (excludeKeywords.some(keyword => matchCourseByKeyword(course, keyword))) return false

    if (includeCourseIds.length || includeKeywords.length) {
      if (includeCourseIds.includes(courseId)) return true
      if (includeKeywords.some(keyword => matchCourseByKeyword(course, keyword))) return true
      return false
    }

    return true
  })
}

export const getRehabMerchantThemeStyle = (merchantConfig = DEFAULT_REHAB_MERCHANT) => ({
  '--rehab-theme-color': merchantConfig.themeColor || DEFAULT_REHAB_MERCHANT.themeColor,
  '--rehab-theme-color-dark': merchantConfig.themeColorDark || merchantConfig.themeColor || DEFAULT_REHAB_MERCHANT.themeColorDark,
  '--rehab-theme-color-light': merchantConfig.themeColorLight || DEFAULT_REHAB_MERCHANT.themeColorLight,
  '--rehab-accent-color': merchantConfig.accentColor || DEFAULT_REHAB_MERCHANT.accentColor
})

export const registerRehabMerchantConfigs = (configs = {}) => {
  Object.keys(configs).forEach(key => {
    const normalizedKey = normalizeMerchantKey(key)
    if (!normalizedKey) return
    merchantConfigs[normalizedKey] = {
      ...DEFAULT_REHAB_MERCHANT,
      ...configs[key],
      key: normalizedKey
    }
  })
}
